"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userProfileCompletenessController = function () {
  function userProfileCompletenessController(UsersService, NotificationService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, userProfileCompletenessController);
    this.profileItemOptions = _constants2.default.profileItems;
    this.usersService = UsersService;
    this.notificationService = NotificationService;
  }

  (0, _createClass3.default)(userProfileCompletenessController, [{
    key: "resetPayto",
    value: function resetPayto() {
      var _this = this;

      if (!confirm('Are you sure you want to reset PayTo for this user?')) return;
      this.usersService.resetPayto(this.userId, function () {
        return _this.notificationService.success('PayTo reset successful.');
      }, function () {
        return _this.notificationService.error('PayTo reset failed.');
      });
    }
  }, {
    key: "hasItem",
    value: function hasItem(item) {
      return this.profileItems & item;
    }
  }, {
    key: "requiresGuardianApproval",
    value: function requiresGuardianApproval() {
      return this.providerInfo.requiresGuardianApproval || this.hasGuardian();
    }
  }, {
    key: "hasGuardian",
    value: function hasGuardian() {
      return this.providerInfo.guardians != null && this.providerInfo.guardians.length > 0;
    }
  }, {
    key: "hasApprovedGuardian",
    value: function hasApprovedGuardian() {
      if (!this.hasGuardian()) return false;

      return this.providerInfo.guardians[0].status == 2;
    }
  }]);
  return userProfileCompletenessController;
}();

exports.default = userProfileCompletenessController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/user-profile-completeness/user-profile-completeness.controller.js
 **/